import './logo.scss';

import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import logoPST from '../../assets/pst-logo.svg';

const Logo = ({
    className: customClassName, style, small, smallPlus, large, onClick, ...rest
}) => {
    const className = classnames({
        'pst-logo': true,
        small,
        smallPlus,
        large,
        clickable: !!onClick,
        [customClassName]: customClassName,
    });

    return <img alt="pst logo" src={logoPST} className={className} style={style} onClick={onClick} {...rest} />;
};

Logo.propTypes = {
    /** Additional css classes */
    className: PropTypes.string,
    /** Custom inline styles */
    style: PropTypes.object,
    /** Apply small size styling */
    small: PropTypes.bool,
    /** Apply smallPlus size styling */
    smallPlus: PropTypes.bool,
    /** Apply large size styling */
    large: PropTypes.bool,
    /**
     * function(event: object, checked: boolean) => void
     * Applies the 'cursor: pointer;' style if truthy
     */
    onClick: PropTypes.func,
};

Logo.defaultProps = {
    className: '',
    style: {},
    small: false,
    smallPlus: false,
    large: false,
    onClick: undefined,
};

export { Logo };
